module.exports = __webpack_public_path__ + "img/金银花.aa2c4f81.jpg";